import { render, staticRenderFns } from "./Curators.vue?vue&type=template&id=70d070fe"
import script from "./Curators.vue?vue&type=script&lang=ts"
export * from "./Curators.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports